import { useEffect, useState } from 'react';
import { WifiOff } from 'lucide-react';

/** Persistent compact banner — never claim network actions succeeded while offline. */
export const PortalOfflineBanner = () => {
  const [offline, setOffline] = useState(() => typeof navigator !== 'undefined' && !navigator.onLine);
  useEffect(() => {
    const goOffline = () => setOffline(true);
    const goOnline = () => setOffline(false);
    window.addEventListener('offline', goOffline);
    window.addEventListener('online', goOnline);
    return () => {
      window.removeEventListener('offline', goOffline);
      window.removeEventListener('online', goOnline);
    };
  }, []);
  if (!offline) return null;
  return (
    <div className="portal-offline-banner" role="status" aria-live="polite" data-testid="portal-offline-banner">
      <WifiOff size={15} aria-hidden="true" />
      <span>You’re offline. Some information may be out of date.</span>
    </div>
  );
};
